import Vue from 'vue'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { Cookies, LocalStorage } from 'quasar'
import { BugsnagClient } from './bugsnag'
import Store from 'src/store'
import getEnv from 'src/getEnv'

import { isLiteralObject } from 'src/helpers'

Vue.prototype.$axios = axios

const axiosRetryOpts = {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 500
  },
  retryCondition: (error) => {
    return error.response.status === 503
  }
}

axios.defaults.baseURL = getEnv('API')
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Access-Control-Allow-Methods'] = '*'
axios.defaults.headers.common.Authorization = Cookies.get('jwt') ? 'Bearer ' + Cookies.get('jwt') : ''

axios.interceptors.response.use((response) => response, (error) => {
  const { response: { status, data } } = error
  switch (status) {
    case 401:
    case 403:
      setTimeout(() => {
        LocalStorage.remove('module')
        LocalStorage.remove('user')
        Cookies.remove('jwt')
        LocalStorage.set('force-reload-key-path', Math.random() * 1000)
        window.location.href = '/login'
      }, 500)
      break
    default:
  }

  // Sent custom breadcrumbs and trigger notify to Bugsnag
  const payload = error.config.data
  let metaData = {}

  if (typeof payload === 'string') {
    metaData = { ...metaData, payload: JSON.parse(payload) }
  }

  if (isLiteralObject(payload)) {
    metaData = { ...metaData, payload }
  }

  if (!!payload && payload.constructor === FormData) {
    [...payload.entries()].forEach((p) => {
      const [k, v] = p
      metaData.payload = {}
      metaData.payload[k] = v
    })
  }

  Store().dispatch('notify/FETCH_ERROR', error)

  if (status?.toString()?.startsWith('4')) {
    BugsnagClient.leaveBreadcrumb('Error response', data)
  }

  BugsnagClient.leaveBreadcrumb('Request payload', metaData)
  BugsnagClient.notify(new Error(error))

  return Promise.reject(error)
})

axiosRetry(axios, axiosRetryOpts)

export { axios }
